import React from 'react';
import { Layout, Result, Typography, Card, Button } from 'antd';
import {
    CheckCircleOutlined,
    EditOutlined,
    LikeOutlined,
    DislikeOutlined,
    EyeOutlined
} from '@ant-design/icons';

const { Content } = Layout;
const { Text, Paragraph } = Typography;

const SuccessPage = ({ action, documentName, recipientName }) => {
    const getSuccessConfig = () => {
        switch (action) {
            case 'signed':
                return {
                    icon: <EditOutlined style={{ fontSize: 72, color: '#52c41a' }} />,
                    title: 'Document Signed Successfully!',
                    subtitle: `Thank you, ${recipientName || 'User'}! Your signature has been recorded.`,
                    message: 'The document owner has been notified of your signature.'
                };
            case 'approved':
                return {
                    icon: <LikeOutlined style={{ fontSize: 72, color: '#52c41a' }} />,
                    title: 'Document Approved!',
                    subtitle: `Thank you, ${recipientName || 'User'}! You have approved this document.`,
                    message: 'The document owner has been notified of your approval.'
                };
            case 'rejected':
                return {
                    icon: <DislikeOutlined style={{ fontSize: 72, color: '#faad14' }} />,
                    title: 'Document Rejected',
                    subtitle: `Your rejection has been recorded.`,
                    message: 'The document owner has been notified of your decision.'
                };
            case 'viewed':
                return {
                    icon: <EyeOutlined style={{ fontSize: 72, color: '#1890ff' }} />,
                    title: 'Document Viewed',
                    subtitle: `Thank you for viewing "${documentName || 'the document'}".`,
                    message: 'You can close this window now.'
                };
            default:
                return {
                    icon: <CheckCircleOutlined style={{ fontSize: 72, color: '#52c41a' }} />,
                    title: 'Action Completed!',
                    subtitle: 'Your action has been recorded successfully.',
                    message: 'The document owner has been notified.'
                };
        }
    };

    const config = getSuccessConfig();

    return (
        <Layout style={{ minHeight: '100vh', background: '#f5f5f5' }}>
            <Content style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: 40
            }}>
                <Card
                    style={{
                        maxWidth: 500,
                        width: '100%',
                        textAlign: 'center',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
                    }}
                >
                    <Result
                        icon={config.icon}
                        title={config.title}
                        subTitle={config.subtitle}
                    />

                    {documentName && (
                        <div style={{
                            background: '#f6ffed',
                            border: '1px solid #b7eb8f',
                            padding: 16,
                            borderRadius: 8,
                            marginBottom: 16
                        }}>
                            <Text strong>Document: </Text>
                            <Text>{documentName}</Text>
                        </div>
                    )}

                    <Paragraph type="secondary" style={{ marginTop: 16 }}>
                        {config.message}
                    </Paragraph>

                    <div style={{
                        background: '#fafafa',
                        padding: 20,
                        borderRadius: 8,
                        marginTop: 24
                    }}>
                        <Text type="secondary">
                            You can safely close this window now.
                        </Text>
                    </div>

                    <Button
                        type="primary"
                        style={{ marginTop: 24 }}
                        onClick={() => window.close()}
                    >
                        Close Window
                    </Button>
                </Card>
            </Content>
        </Layout>
    );
};

export default SuccessPage;
